import React from 'react';
import { FormattedMessage } from 'react-intl';

const CalendarSelectionStrings = {
  description: <FormattedMessage
    id="hosting.modal_sync_cal_select.pick_calendar_sync_info"
    defaultMessage="All events from this calendar will be synced with your Peerspace calendar."
  />
};

export default CalendarSelectionStrings;
